angular.module('bmsApp.zone', [])
	.config([
		'$stateProvider', 'uiGmapGoogleMapApiProvider', function config($stateProvider,
																		uiGmapGoogleMapApiProvider) {

			$stateProvider

				.state('main.zone', {
					url: '^/zone/index',
					views: {
						'main@main': {
							templateUrl: 'ng/global/zone/templates/ZoneIndex.html',
							controller: 'ZoneIndexCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Zones'}
				})

			;

		}]);
